import React from 'react';
import parse from 'html-react-parser';

import DefaultFooterTemplate from 'templates/sections/defaultFooter.html';

import FooterButton from './FooterButton';

const Footer = ({ footerType = 'integrations_portal', theme = 'light' }) => {
  if (footerType === 'integrations_portal') {
    return (
      <footer className="integrationsPortal-footer">
        <h3 className="integrationsPortal-footer-title">Need help?</h3>
        <p className="integrationsPortal-footer-desc">
          If you need help with your integration, please contact us at{' '}
          <a href="mailto:developers@escrow.com" className="integrationsPortal-footer-link">
            developers@escrow.com
          </a>{' '}
          and we are more than happy to help.
        </p>
        <div className="integrationsPortal-footer-nav">
          <FooterButton link={{ type: 'internal', route: '/api/docs', newTab: true }}>
            View Documentation
          </FooterButton>
          <FooterButton link={{ type: 'app', route: '/integrations/portal/faqs' }}>
            Frequently Asked Questions
          </FooterButton>
        </div>
      </footer>
    );
  }

  return parse(
    DefaultFooterTemplate.render({
      theme: theme,
      footerType: footerType,
      javascript_config: window.config,
      support_phone_number: window.config.support_phone_number,
    })
  );
};

export default Footer;
